/*
 * File: status-bar.ts
 * File Created: 2024-10-21 09:11:58
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-21 09:14:41
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class StatusBar extends BaseComponent {
    @Prop({ type: Number, default: 100 })
    max!: number;
}
